import { render } from "./resume-header-card.vue?vue&type=template&id=5588d4d7"
import script from "./resume-header-card.vue?vue&type=script&lang=js"
export * from "./resume-header-card.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__